import { DragEvent } from "react";
import { Card } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { GripVertical } from "lucide-react";

interface ColumnListProps {
  columns: string[];
  usedColumns?: string[];
}

export const ColumnList = ({ columns, usedColumns = [] }: ColumnListProps) => {
  const handleDragStart = (e: DragEvent<HTMLDivElement>, column: string) => {
    e.dataTransfer.setData("text/plain", column);

    // Create a custom drag image
    const dragPreview = document.createElement("div");
    dragPreview.className =
      "px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium shadow-lg max-w-fit";
    dragPreview.textContent = column;
    document.body.appendChild(dragPreview);

    // Position the preview slightly offset from cursor
    e.dataTransfer.setDragImage(dragPreview, 20, 20);

    // Remove the preview element after drag starts
    requestAnimationFrame(() => {
      document.body.removeChild(dragPreview);
    });
  };

  const availableColumns = columns.filter((col) => !usedColumns.includes(col));

  if (availableColumns.length === 0) return null;

  return (
    <Card className="p-2 mb-4">
      <p className="text-sm text-muted-foreground mb-2">
        Drag fields to map them
      </p>
      <ScrollArea className="min-h-[50px] max-h-[150px]">
        <div className="flex flex-wrap gap-2">
          {availableColumns.map((column, index) => (
            <div
              key={index}
              draggable
              onDragStart={(e) => handleDragStart(e, column)}
              className="flex items-center gap-1 px-2 py-1 rounded-md bg-muted/50 cursor-move hover:bg-muted/70 transition-colors text-xs group"
            >
              <GripVertical className="h-3 w-3 text-muted-foreground group-hover:text-foreground transition-colors" />
              <span>{column}</span>
            </div>
          ))}
        </div>
      </ScrollArea>
    </Card>
  );
};
